import '.c9{flex-shrink:0;}.ssr-plugin'
import '.cb{padding:1rem;}.ssr-plugin'
import '.a7{width:100%;}.ssr-plugin'
import '.b9{height:100%;}.ssr-plugin'
import '.bc{border:none;}.ssr-plugin'
import '.bm{background-color:transparent;}.ssr-plugin'
import '.fd{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.cq{position:sticky;}.ssr-plugin'
import '.fe{top:4rem;}.ssr-plugin'
import '.ff{z-index:7;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.fg{padding-bottom:1rem;}.ssr-plugin'
import '.v{margin-bottom:1rem;}.ssr-plugin'
import '.fh{border-bottom:var(--blue-border);}.ssr-plugin'
import '.a0{position:fixed;}.ssr-plugin'
import '.cf{top:0;}.ssr-plugin'
import '.bt{left:0px;}.ssr-plugin'
import '.bu{right:0px;}.ssr-plugin'
import '.fi{bottom:0px;}.ssr-plugin'
import '.ee{z-index:9999;}.ssr-plugin'
import '.fj{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.e6{justify-content:flex-end;}.ssr-plugin'
import '.cd{flex:1;}.ssr-plugin'
import '.bi{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="c9 cb a7 b9 bc bm fd"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a b ab"
    >
      <div className="cq fe ff ae fg v fh a"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="a0 cf bt bu fi ee ae fj a b"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="cb a e6 fh"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="cd bi">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
